"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Withdrawals = exports.Withdraw = void 0;
class Withdraw {
    constructor(withdraw) {
        this.id = 0;
        this.date = new Date();
        this.coin = '';
        this.amount = 0;
        this.fee = 0;
        this.status = '';
        this.address = '';
        this.txid = '';
        this.auth = '';
        if (!withdraw)
            return;
        Object.assign(this, withdraw);
    }
}
exports.Withdraw = Withdraw;
class Withdrawals {
    constructor(withdrawals) {
        this.list = [];
        this.isLoaded = false;
        if (!withdrawals)
            return;
        this.isLoaded = withdrawals.isLoaded;
        this.list = withdrawals.list;
    }
}
exports.Withdrawals = Withdrawals;
//# sourceMappingURL=withdraw.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/exchange-common/models/withdraw.js
// module id = 207
// module chunks = 0